import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from './button.tsx';
import { cn } from '../../lib/utils.ts';

export function SlidePanel({ 
  isOpen, 
  onClose, 
  title,
  children,
  footer,
  className
}) {
  return (
    <>
      {/* Backdrop overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/30 backdrop-blur-sm transition-opacity z-40"
          onClick={onClose}
        />
      )}
      
      <div
        className={cn(
          "fixed inset-y-0 right-0 w-[500px] bg-white shadow-2xl transform transition-transform duration-300 ease-in-out z-50 flex flex-col rounded-l-2xl border-l",
          isOpen ? "translate-x-0" : "translate-x-full",
          className
        )}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b bg-gray-50/80 rounded-tl-2xl">
          <div className="flex items-center gap-3">
            <Button variant="ghost" size="icon" onClick={onClose} className="hover:bg-white/50">
              <ArrowLeft className="h-5 w-5" />
            </Button>
            <h1 className="text-xl font-semibold text-gray-800">{title}</h1>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto">
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div className="p-6 border-t bg-gray-50/80">
            {footer}
          </div>
        )}
      </div>
    </>
  );
}